import { FormPasswordController, LoginResponse } from "../../core";
import { AuthLoginRepositoryImpl } from "../interactors/AuthLoginRepositoryImpl.ts";

export class FormPasswordControllerImpl implements FormPasswordController {
    async tryLogin(token: string): Promise<LoginResponse> {
        const repository = new AuthLoginRepositoryImpl();
        return await repository.login(token);
    }

}